import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const FilterPercentageIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M12 0C5.38 0 0 5.38 0 12C0 18.62 5.38 24 12 24C18.62 24 24 18.62 24 12C24 5.38 18.62 0 12 0ZM22 12C22 13.41 21.71 14.74 21.18 15.96L13 11.42V2.05C18.05 2.55 22 6.82 22 12ZM12 22C6.49 22 2 17.51 2 12C2 6.82 5.95 2.55 11 2.05V12C11 12.36 11.2 12.7 11.51 12.87L20.2 17.7C18.39 20.29 15.39 22 12 22Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

FilterPercentageIcon.displayName = 'FilterPercentageIcon';
